'use strict';
import isNumber from 'lodash/isNumber';

export const DEFAULT_PAGE_SIZE = 20;

export class CachedFilter {
  constructor(pageSize) {
    this.filtered = [];
    this.rendered = [];
    this.pageSize = isNumber(pageSize) ? pageSize : DEFAULT_PAGE_SIZE;
    this.pageBufferRemaining = this.pageSize;
  }

  addOne($scope, instance) {
    const filteredLength = this.filtered.length;
    let renderedLength = this.rendered.length;
    const minSize = Math.min(this.pageSize, filteredLength);

    while (renderedLength--) {
      this.rendered.pop();
    }
    renderedLength = 0;
    if (this.pageBufferRemaining < minSize) this.pageBufferRemaining = minSize;
    for (let i = 0; i < filteredLength; i++) {
      if (this.filtered[i] === instance) {
        renderedLength++;
        this.rendered.push(this.filtered[i]);
      } else if (this.pageBufferRemaining > 0) {
        this.pageBufferRemaining--;
        this.rendered.push(this.filtered[i]);
        renderedLength++;
      }
    }

    if (renderedLength < minSize) {
      this.pageBufferRemaining = minSize - renderedLength;
      $scope.$evalAsync(() => {
        this.render($scope, null, 0);
      });
      return;
    }

    if ($scope.updateView$) {
      $scope.updateView$.next();
    }
  }

  render($scope, triesLeft = 1) {
    const filteredLength = this.filtered.length;
    let renderedLength = this.rendered.length;
    const minSize = Math.min(this.pageSize, filteredLength);

    while (renderedLength--) {
      this.rendered.pop(); // store each item that's already rendered
    }
    renderedLength = 0;
    if (this.pageBufferRemaining < minSize) this.pageBufferRemaining = minSize;
    for (let i = 0; i < filteredLength; i++) {
      if (this.pageBufferRemaining > 0) {
        this.pageBufferRemaining--;
        this.rendered.push(this.filtered[i]);
        renderedLength++;
      }
    }

    if (renderedLength < minSize && triesLeft-- > 0) {
      this.pageBufferRemaining = minSize - renderedLength;
      $scope.$evalAsync(() => {
        this.render($scope, triesLeft);
      });
      return;
    } else if (renderedLength < minSize && triesLeft === 0) {
      console.warn('Infinite render loop detected!');
    }

    if ($scope.updateView$) {
      $scope.updateView$.next();
    }
  }

  addPage() {
    const filteredLength = this.filtered.length;
    const renderedLength = this.rendered.length;
    this.pageBufferRemaining = Math.min(filteredLength, this.pageSize + renderedLength);
  }
}



// WEBPACK FOOTER //
// ./src/js/core-utilities/filters/CachedFilter.js